import { config } from '@/lib';

const StarList = (props) => {
  let { data, max, clickfrom } = props;
  data = data || [];
  max = max || 99999;

  return (
    <>
      {data.map((item, i) => {
        var item = data[i],
          isHidden = i >= max;
        item._id = item._id || item.id;

        return (
          <li
            key={item._id}
            data-roomid={item._id}
            className={`star-item ${isHidden ? ' hidden' : ''}`}
          >
            <a
              href={`/${item._id}`}
              className="index-target-btn"
              target="_blank"
              data-foundtime={item.found_time}
              data-id={item._id + '?clickfrom=' + clickfrom}
            >
              <div className="star-item-pic">
                <img
                  className="lazyimg"
                  src={config.blankImg}
                  data-original={item.app_pic_url || item.pic || item.pic_url}
                  alt={item.nick_name}
                />
              </div>

              <p className="star-item-name">
                <span title={item.nick_name}>{item.nick_name}</span>
              </p>
              <p className="star-item-info">
                {item.live ? (
                  <span
                    className="star-item-num"
                    data-count="<%= item.visiter_count  %>"
                  >
                    0人在看
                  </span>
                ) : (
                  '休息中'
                )}
              </p>

              {item.live ? (
                <>
                  {' '}
                  <span className="icon-base icon-base-play"></span>
                  <i className="icon-base icon-base-live">直播</i>
                </>
              ) : (
                '休息中'
              )}
            </a>
          </li>
        );
      })}
    </>
  );
};

export default StarList;
